import React, { useEffect, useState } from 'react'
import { Button, Card, IconButton, Typography } from '@material-ui/core'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import { ArrowDownwardOutlined, ArrowUpwardOutlined } from '@material-ui/icons'
import { ReturnButton } from '@auteco/components/snopComponents/ReturnButton'
import {  initialAlert, statesSnop } from '@auteco/constants'
import {
  updateMaterialStatus,
  getConsolidadoMaterialInfo,
  getComportamientoMaterial,
  getgroupIdByMaterial,
  postModelosAplicacion
} from '@auteco/services/snopServices'

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js'
import { Alert } from '../Alert'
import useStyles from './styles'
import {
  EventsTable,
  FinalValuesTable,
} from './components'
import { MaterialInfoTable } from './components/MaterialInfoTable'

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
)

const initialState = {
  graphic: false,
  info: false,
  features: false,
  baseline: false,
  events: false,
  final: false,
}

const DetailsPage = ({
  materialId,
  materials,
  handleReturnMainPage,
  rol,
  setMaterialChanged,
  materialChanged,
  setMaterials,
  detailsVisible,
  setDetailsVisible,
}) => {
  const material = materials.find((m) => m.id === materialId)
  const [models, setModels] = useState([])
  const [showTables, setShowTables] = useState(initialState)
  const [alertInfo, setAlertInfo] = useState(initialAlert)
  const [groupId, setGroupId] = useState(0)
  const [consolidadoMaterialInfo, setConsolidadoMaterialInfo] = useState([])
  const [comportamientoMaterial, setComportamientoMaterial] = useState([])

  const getComportamientoApi = async () => {
    const comportamientoMaterialData = await getComportamientoMaterial(material.id)
    setComportamientoMaterial(comportamientoMaterialData)
  }
  const getconsolidadoInfo = async () => {
    const consolidadoMaterialInfoData = await getConsolidadoMaterialInfo(
      material.id,
    )
    if (consolidadoMaterialInfoData) {
      setConsolidadoMaterialInfo(consolidadoMaterialInfoData)
    }
  }
  const getGroupId = async () => {
    const groupIdByMaterial = await getgroupIdByMaterial(material.id)
    setGroupId(groupIdByMaterial.grupo_id)
  }

  const classes = useStyles()

  const updateMaterial = async ({ status }) => {
    setMaterialChanged(materialChanged + 1)
    const body = {
      material: `${material.id}`,
      estado: status,
    }
    const { success } = await updateMaterialStatus({ params: body })
    if (success === 1) {
      setDetailsVisible(false)
      if (rol === 1) {
        const updatedMaterials = materials.map((item) =>
          item.id === material.id ? { ...item, fc: status } : item,
        )
        setMaterials(updatedMaterials)
      } else if (rol === 2) {
        const updatedMaterials = materials.map((item) =>
          item.id === material.id ? { ...item, fc: status, fg: status } : item,
        )
        setMaterials(updatedMaterials)
      }
      setAlertInfo(initialAlert)
    }
  }

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }

  const handleFinishMaterial = async () => {
    await updateMaterial({ status: statesSnop.finalizado })
    handleReturnMainPage()
    onCloseAlert()
  }

  const closeMaterial = async () => {
    setAlertInfo({
      title: '¡Espera!',
      content: 'Estás a punto de finalizar este material, ¿deseas continuar?',
      textBtn1: 'Cancelar',
      textBtn2: 'Continuar',
      open: true,
      onClose: onCloseAlert,
      funcBtn: handleFinishMaterial,
    })
  }
  const handleShowSection = ({ section }) => {
    if (section === 'info') {
      getComportamientoApi()
    }
    if (section === 'final' || section === 'features') {
      getconsolidadoInfo()
    }
    if(section === 'events'){
      getGroupId()
    }
    setShowTables((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }))
  }

  const getApplicationModels = async () => {
    const modelsForApplication = await postModelosAplicacion({
      params: {
        materiales: [material.id.toString()],
      },
    })
    setModels(modelsForApplication.data)
  }

  useEffect(() => {
    setShowTables(initialState)
    getApplicationModels();
  }, [detailsVisible])

  if (!material) return null

  return (
    <>
      <Alert
        title={alertInfo.title}
        content={alertInfo.content}
        textBtn1={alertInfo.textBtn1}
        textBtn2={alertInfo.textBtn2}
        funcBtn={alertInfo.funcBtn}
        open={alertInfo.open}
        onClose={onCloseAlert}
      />
      <ReturnButton onClick={handleReturnMainPage} />
      <Card className={classes.cardContainer}>
        <CardTitle title={`Material ${material.id}`} subTitle={`${material.texto} 
           ( LT:  ${material.leadtime} )`}  />
           <div>
            <p>Modelos</p>
            <div style={{
               display: "grid",
               gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
               gridGap: "10px",
               width: "100%" 
            }}>
              {models.map((model) => (
                <div  style={{border:"1px solid black", padding: '4px',  height:'40px '}}>
                  <p style={{
                    fontSize: "calc(5px + 0.5vw)",
                    fontWeight: "bold",
                    color: "black",
                    textAlign: "center",
                  }} >{model.modelo_aplicacion}</p>
                </div>
              ))}
            </div>
           </div>
        <Card
          className={
            showTables.info
              ? classes.dropdownContainerSelected
              : classes.dropdownContainer
          }
        >
          <div className={classes.dropdown}>
            <Typography
              className={
                showTables.info ? classes.titleSelected : classes.title
              }
            >
              Información
            </Typography>
            <IconButton
              className={classes.arrowBtn}
              onClick={() => handleShowSection({ section: 'info' })}
            >
              {showTables.info ? (
                <ArrowUpwardOutlined />
              ) : (
                <ArrowDownwardOutlined />
              )}
            </IconButton>
          </div>
          {showTables.info && (
            <>
              {comportamientoMaterial ? (
                
                <Card style={{marginTop:"20px"}} className={classes.headerContainer}>
                  <Typography>
                    <span className={classes.headerTitle}>
                      Ventas promedio mensuales:{' '}
                      {comportamientoMaterial?.ventasPromedio
                        ? comportamientoMaterial.ventasPromedio.slice(0, 10)
                        : ''}
                    </span>
                  </Typography>
                  <Typography>
                    <span className={classes.headerTitle}>
                      BIAS:{' '}
                      {comportamientoMaterial.bias
                        ? `${`${
                            parseFloat(comportamientoMaterial.bias) * 100
                          }`.slice(0, 4)}%`
                        : ' - '}
                    </span>
                  </Typography>
                  <Typography>
                    <span className={classes.headerTitle}>
                      MAPE{' '}
                      {comportamientoMaterial.mape
                        ? `${`${parseFloat(comportamientoMaterial.mape)}`.slice(
                            0,
                            4,
                          )}%`
                        : ' - '}
                    </span>
                  </Typography>
                  <Typography>
                    <span className={classes.headerTitle}>
                      Aporte a la venta mensual:{' '}
                      {comportamientoMaterial.aporteVentaMensual
                        ? `${`${
                            parseFloat(
                              comportamientoMaterial.aporteVentaMensual,
                            ) * 100
                          }`.slice(0, 4)}%`
                        : ' - '}
                    </span>
                  </Typography>
                </Card>
              ) : (
                <></>
              )}
            </>
          )}
        </Card>
        <Card
          className={
            showTables.features
              ? classes.dropdownContainerSelected
              : classes.dropdownContainer
          }
        >
          <div className={classes.dropdown}>
            <Typography
              className={
                showTables.features ? classes.titleSelected : classes.title
              }
            >
              Tabla general
            </Typography>
            <IconButton
              className={classes.arrowBtn}
              onClick={() => handleShowSection({ section: 'features' })}
            >
              {showTables.features ? (
                <ArrowUpwardOutlined />
              ) : (
                <ArrowDownwardOutlined />
              )}
            </IconButton>
          </div>
          {showTables.features && (
            <>
              <MaterialInfoTable
                consolidadoMaterialInfo={consolidadoMaterialInfo} leadTime={material.leadtime}
              />
              <FinalValuesTable
              consolidadoMaterialInfo={consolidadoMaterialInfo} leadTime={5}
            />
            </>
          )}
        </Card>
        <Card
          className={
            showTables.events
              ? classes.dropdownContainerSelected
              : classes.dropdownContainer
          }
        >
          <div className={classes.dropdown}>
            <Typography
              className={
                showTables.events ? classes.titleSelected : classes.title
              }
            >
              Tabla de eventos
            </Typography>
            <IconButton
              className={classes.arrowBtn}
              onClick={() => handleShowSection({ section: 'events' })}
            >
              {showTables.events ? (
                <ArrowUpwardOutlined />
              ) : (
                <ArrowDownwardOutlined />
              )}
            </IconButton>
          </div>
          {showTables.events && (
            <EventsTable
              groupId={groupId}
              material={material.id}
              getconsolidadoInfo={getconsolidadoInfo}
            />
          )}
        </Card>
        {(rol === 1 &&
          material.fg !== 2 &&
          material.fg !== 1 &&
          material.fc !== 1 &&
          material.fc !== 2) ||
        (rol === 2 && material.fg !== 2 && material.fg !== 1) ? (
          <div className={classes.closeBtn}>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: '0 auto' }}
              onClick={closeMaterial}
            >
              Finalizar
            </Button>
          </div>
        ) : (
          <></>
        )}
      </Card>
    </>
  )
}

export { DetailsPage }
